module.exports = __webpack_public_path__ + "static/media/RobotoCondensed-BoldItalic.659aace7.ttf";